var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8h1a1 1 0 000-2H5a1 1 0 000 2zm0 2a1 1 0 000 2h6a1 1 0 000-2H5zm11-3.06a1.307 1.307 0 00-.06-.27v-.09a1.07 1.07 0 00-.19-.28l-6-6a1.07 1.07 0 00-.28-.19.32.32 0 00-.09 0A.88.88 0 009.05 0H3a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V7v-.06zm-6-3.53L12.59 6H11a1 1 0 01-1-1V3.41zM14 17a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1h5v3a3 3 0 003 3h3v9zm-3-3H5a1 1 0 000 2h6a1 1 0 000-2z",
    fill: "#1D426D"
  })));
}

export default SvgFileIcon;